var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00A478"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97804 8.14944V5.84976H4.94019V3.83398H13.4291V5.87815H10.3913V8.14944H7.97804Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11353 7.2408C12.2933 7.2408 13.94 8.12093 14.1388 8.40484C13.94 8.68875 12.3217 9.11462 9.11353 9.11462C5.93372 9.11462 4.28703 8.68875 4.08829 8.40484C4.28703 8.09254 5.93372 7.2408 9.11353 7.2408ZM9.11353 7.01367C6.07567 7.01367 3.63403 7.63828 3.63403 8.40484C3.63403 9.1714 6.07567 9.79601 9.11353 9.79601C12.1514 9.79601 14.593 9.1714 14.593 8.40484C14.593 7.63828 12.1514 7.01367 9.11353 7.01367Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3913 8.85958V7.26967C9.9938 7.24128 9.56793 7.21289 9.14207 7.21289C8.74459 7.21289 8.3755 7.21289 8.00642 7.24128V8.83119C8.34711 8.83119 8.74459 8.85958 9.14207 8.85958C9.56793 8.88797 9.9938 8.88797 10.3913 8.85958ZM9.11367 9.79649C8.7162 9.79649 8.34711 9.79649 7.97803 9.7681V13.9984H10.3629V9.7397C9.96541 9.7681 9.53954 9.79649 9.11367 9.79649Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.60c6a9811f94c6eaeea6f5854741e742.svg";
export { ForwardRef as ReactComponent };